import QueryString from 'qs';

export const normalizeRemainsSearchParams = (
  searchParams: QueryString.ParsedQs
) => {
  searchParams.product_ids = searchParams.product_ids?.map(
    (product_id: string) => Number(product_id)
  );

  searchParams.organisation_ids = searchParams.organisation_ids?.map(
    (organisation_id: string) => Number(organisation_id)
  );

  searchParams.warehouse_ids = searchParams.warehouse_ids?.map(
    (warehouse_id: string) => Number(warehouse_id)
  );

  return searchParams;
};
